import { Breadcrumb, Button, Col, Form, Input, Row, Select, Steps, message } from "antd";
import "../spf.scss";
import "./spf-authentication.scss";
import { _adr } from "../../../../address";
import { useTranslation } from "react-i18next";
import { EditOutlined, HomeOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import { useNavigate } from "react-router-dom";
import { useAPIPublic, useDealer } from "../../../../tools/api";
import { useEffect, useState } from "react";
import ReactInputMask from "react-input-mask";
import OTP from "../../../auxiliary/otp-modal/otp";
import { useDispatch, useSelector } from "react-redux";
import { simcardPurchase } from "../../../../reducer/serviceReducer";
import Loading from "../../../auxiliary/loader/loading";
import { getFieldDocument, regexFormater, validateInput } from "../../../../tools/tools";
import SPFShopLayout from "../spf-shop-layout";
const SPFAuthentication = () => {
	const [t] = useTranslation("global");
	const nav = useNavigate();
	const [frmCert] = Form.useForm();

	const { queryCertType } = useAPIPublic();
	const { queryCountSimCardByCertNo } = useDealer();

	const [certType, setCertType] = useState([]);

	const [isValidCert, setisValidCert] = useState(false);
	const [countSimcard, setCountSimcard] = useState(0);

	const [isOpenOtp, setIsOpenOtp] = useState(false);

	const dispatch = useDispatch();

	const formData = useSelector((state) => state?.from?.spForeign);

	const [isLoading, setIsLoading] = useState(false);

	const [labelMsisdn, setLabelMsisdn] = useState("شماره همراه");
	const [txtCertType, setTxtCertType] = useState("");

	const [isPromotionTypeOneMonth, setPromotionTypeOneMonth] = useState(formData?.spbundle?.bundlePromotionType == 2 || false);

	console.log(formData);
	useEffect(() => {
		const callServCertType = async () => {
			let response = await queryCertType();
			if (response) {
				if (isPromotionTypeOneMonth) {
					response = response.filter((item) => item.value == 120);
				} else {
					response = response.filter((item) => item.value !== 120);
				}
				setCertType(response);
			}
		};
		callServCertType();
	}, []);

	//handle Call Back OTP
	const handleGetToken = (token) => {
		setIsOpenOtp(false);
		if (token) {
			dispatch(
				simcardPurchase({
					spForeign: {
						...formData,
						token: token.token,
						certtype: frmCert.getFieldValue("certtype"),
						documenttype: getFieldDocument(frmCert.getFieldValue("certtype")),
						txtCertType: certType.find((item) => item.value === frmCert.getFieldValue("certtype"))?.name,
						certno: frmCert.getFieldValue("certno"),
						smsmobileno: regexFormater(frmCert.getFieldValue("smsmobileno") || "").removeSpace(),
					},
				}),
			);
			nav(_adr.Root + _adr.SimCardPurchase.foreigners + _adr.SimCardPurchase.foreignersChild.Profile);
		}
	};

	//handle Submit Form
	const handleSubmit = async () => {
		setIsLoading(true);
		try {
			if (isValidCert) {
				let valid = await frmCert.validateFields();
				if (valid) {
					if (isPromotionTypeOneMonth) {
						dispatch(
							simcardPurchase({
								spForeign: {
									...formData,
									token: valid.certno,
									certtype: valid.certtype,
									documenttype: getFieldDocument(valid.certtype),
									txtCertType: certType.find((item) => item.value === valid.certtype)?.name,
									certno: valid.certno,
									smsmobileno: valid?.smsmobileno ? regexFormater(valid?.smsmobileno || "").removeSpace() : "9990000000",
								},
							}),
						);
						nav(_adr.Root + _adr.SimCardPurchase.foreigners + _adr.SimCardPurchase.foreignersChild.Profile);
					} else {
						setIsOpenOtp(true);
					}
				}
			} else {
				let valid = await frmCert.validateFields();
				if (valid) {
					let payload = {
						certtype: valid.certtype,
						certno: valid.certno,
					};
					let response = await queryCountSimCardByCertNo(payload);
					if (response !== null) {
						setisValidCert(true);
						setCountSimcard(response);
						if (response === 0) {
							setLabelMsisdn("شماره همراه معرف");
						} else {
							setLabelMsisdn("شماره همراه");
						}
					}
				}
				setIsLoading(false);
			}
		} catch (error) {
			console.log(error.message);
			setIsLoading(false);
		}
	};
	return (
		<>
			<SPFShopLayout>
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("simcardpurchase.foreigners.title") }]}
					/>
					<div className="title-page">
						<h3>{t("simcardpurchase.foreigners.title")}</h3>
						<p></p>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className="g-layout-main sp-container">
						<div className="g-format-page">
							<div className="g-body-format-page">
								<div className="g-format-steps">
									<div className="holder-step">
										<Steps
											size="small"
											className="step-wizard"
											current={1}
											items={[
												{
													title: "بسته آغازین",
												},
												{
													title: "احراز هویت",
												},
												{
													title: "اطلاعات هویتی",
												},
												{
													title: "پیش فاکتور",
												},
												{
													title: "سند",
												},
											]}
										/>
									</div>
								</div>
								<div className="authentication-container ">
									<div className="container-authen-form">
										<Form form={frmCert} layout="vertical">
											<Row gutter={17}>
												<Col span={8} xl={8} lg={12} md={15} xs={24} sm={24}>
													<Form.Item
														className="input-normal"
														name="certtype"
														rules={[validateInput({ t: t, validate: true })]}
														label="نوع مدرک شناسایی">
														<Select
															disabled={isValidCert ? true : false}
															defaultValue={isPromotionTypeOneMonth ? (certType?.length > 0 ? certType[0].value : "") : ""}>
															{certType.map((item, key) => (
																<Select.Option key={key} value={item.value}>
																	{item.name}
																</Select.Option>
															))}
														</Select>
													</Form.Item>
												</Col>
											</Row>
											<Row gutter={17}>
												<Col span={8} xl={8} lg={12} md={15} xs={24} sm={24}>
													<Form.Item
														className="input-normal"
														name="certno"
														rules={[validateInput({ t: t, validate: true, type: isPromotionTypeOneMonth ? "passport" : "number" })]}
														label="شماره مدرک شناسایی"
														extra={isValidCert && <>تعداد سیم‌کارت‌های فعال شما {countSimcard} می باشد</>}>
														<Input dir="ltr" autoComplete="off" disabled={isValidCert ? true : false} maxLength={isPromotionTypeOneMonth ? 13 : 32} />
													</Form.Item>
												</Col>
											</Row>
											{isValidCert && (
												<>
													{!isPromotionTypeOneMonth && (
														<>
															<Row gutter={17}>
																<Col span={8} xl={8} lg={12} md={15} xs={24} sm={24}>
																	<Form.Item
																		className="input-normal"
																		name="smsmobileno"
																		label={labelMsisdn}
																		rules={[
																			validateInput({
																				t: t,
																				validate: isPromotionTypeOneMonth ? false : true,
																				type: isPromotionTypeOneMonth ? "none" : "msisdnOrg",
																			}),
																		]}>
																		<div>
																			<ReactInputMask mask="0\999 999 99 99" id="refMsisdn" className="msisdn-mask" dir="ltr" />
																		</div>
																	</Form.Item>
																</Col>
															</Row>
														</>
													)}
												</>
											)}
										</Form>
									</div>
								</div>
							</div>
							<div className="g-footer-format-page">
								<div className="row-button">
									<div className="holder-button">
										{isValidCert && (
											<Button className="btn-normal btn-print" icon={<EditOutlined />} type="default" onClick={() => setisValidCert(false)}>
												ویرایش
											</Button>
										)}
									</div>
									<div className="holder-button">
										<Button className="btn-normal btn-aptel" type="primary" danger onClick={handleSubmit}>
											مرحله بعد
										</Button>
										<Button
											className="btn-normal"
											type="default"
											onClick={() => {
												nav(_adr.Root + _adr.SimCardPurchase.foreigners + _adr.SimCardPurchase.foreignersChild.Kit);
											}}>
											بازگشت
										</Button>
									</div>
								</div>
							</div>
						</div>
					</Content>
				</div>
			</SPFShopLayout>

			<OTP
				isOpen={isOpenOtp}
				callback={handleGetToken}
				certno={frmCert.getFieldValue("certno")}
				expiretimebyminute={process.env.REACT_APP_LOGIN_EXPIRE}
				msisdn={frmCert.getFieldValue("smsmobileno")?.toString().replace("0", "").replace(/\s/g, "")}
				sessionid={Date.now()}
				certtype={frmCert.getFieldValue("certtype")}
			/>
			<Loading isOpen={isLoading} />
		</>
	);
};

export default SPFAuthentication;
